import { h } from 'preact';

const renderChildren = (children) =>
  children.map((child, index) => {
    switch (child.type) {
      case 'text':
        if (child.italic) {
          return <em key={index}>{child.value}</em>;
        }
        if (child.bold) {
          return <strong key={index}>{child.value}</strong>;
        }
        return <span key={index}>{child.value}</span>;

      case 'link':
        return (
          <a href={child.url} key={index}>
            {renderChildren(child.children)}
          </a>
        );
      default:
        return null;
    }
  });

const renderParagraphs = (children) =>
  children.map((child, index) => {
    switch (child.type) {
      case 'paragraph':
        return <p key={index}>{renderChildren(child.children)}</p>;
      default:
        return null;
    }
  });

const DescriptionComponent = ({ description }) =>
  description?.children?.length && (
    <div className="body-sm max-w-[500px] pb-2 md:pb-3 text-[12px] leading-[18px]">
      {renderParagraphs(description.children)}
    </div>
  );

const LinkOrDiv = ({href, children, className}) => {
  return href ? (
    <a href={href} className={`${className} hover:opacity-90 transition-opacity`}>
      {children}
    </a>
  ) : (
    <div className={className}>
      {children}
    </div>
  )
}

const MarketingCard = ({
  image,
  mobileImage,
  eyebrow,
  eyebrowTextSize,
  title,
  description,
  ctaText,
  ctaLink,
  color
}) => {
  const classes = {
    container: 'col-span-2  md:pb-0',
    content: 'p-5 sm:pt-64',
  };

  return (
    <div className={`marketing-card relative mb-10 block ${classes.container}`} style={{
      '--marketingTextColor': `${color || '#fff'}`,
    }}>
      <LinkOrDiv className="marketing-card-link relative block" href={ctaLink}>
        <picture >
          <source media="(min-width: 767px)" srcSet={image} />
          <img

            src={mobileImage}
            alt={title}
            className="w-full"
          />
        </picture>
        <div
          className={`absolute left-0 bottom-0 
           w-full text-[var(--marketingTextColor)] ${classes.content}`}
        >
          {!!eyebrow?.length && (
            <div className={eyebrowTextSize ? `${eyebrowTextSize} pb-2 md:pb-3` : 'eyebrow-14 pb-2 md:pb-3'}>{eyebrow}</div>
          )}
          {!!title?.length && (<div className="h4 pb-2 md:pb-3 text-[28px] md:text-[36px]">{title}</div>)}
          {description && <DescriptionComponent description={description} />}
          {!!ctaText && (
            <span className="cta-medium text-[var(--marketingTextColor)] after:bg-[var(--marketingTextColor)] hover:after:bg-[var(--marketingTextColor)] hover:text-[var(--marketingTextColor)] opacity-85 hover:opacity-100 transition-opacity">
              {ctaText}
            </span>
          )}
        </div>
      </LinkOrDiv>
    </div>
  );
};

export default MarketingCard;
